import { __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import isSameYear from 'date-fns/isSameYear';
import isThisYear from 'date-fns/isThisYear';
import { SelectButton } from '../select-button/Component.js';
import '../../../../button/esm/desktop';

var styles = {"yearsTable":"calendar__yearsTable_1cdj4","responsive":"calendar__responsive_1cdj4","inner":"calendar__inner_1cdj4","button":"calendar__button_1cdj4"};
require('./index.css');

var YearsTable = function (_a) {
    var _b;
    var selectedYear = _a.selectedYear, _c = _a.years, years = _c === void 0 ? [] : _c, getYearProps = _a.getYearProps, responsive = _a.responsive;
    var view = function (year) {
        if (selectedYear && isSameYear(selectedYear, year))
            return 'selected';
        if (isThisYear(year))
            return 'current';
        return 'default';
    };
    return (React.createElement("div", { className: cn(styles.yearsTable, (_b = {}, _b[styles.responsive] = responsive, _b)) },
        React.createElement("div", { className: styles.inner }, years.map(function (year) { return (React.createElement(SelectButton, __assign({}, getYearProps(year), { key: year.getFullYear(), view: view(year), className: styles.button }), year.getFullYear())); }))));
};

export { YearsTable };
